import createSupabaseStore from './supabase-table-store'

export default () => createSupabaseStore(
  async (set, supabase, payload) => {
    const {data} = await supabase
      .from('categories')
      .select('*')
      .order('name')
    ;

    set(data);
  },
  'categories',
  []
);